import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { MediaProps, MediaType } from '../media-constant';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import { Link } from '../../../Link';
import { Typography } from '../../../DesignSystemV2/Typography';
import { s3ToCDN } from '@doltech/utils/lib/url';

export const renderFileUpload = (opt: MediaProps) => (props: RenderElementProps) => {
  const { element } = props;
  if (element.type === MediaType.FILE) {
    const {
      fileInfo: { path, name },
    } = element;
    if (!path) return null;
    return (
      <div className="attached-file" contentEditable={false}>
        File đính kèm:{' '}
        <Link
          style={{ whiteSpace: 'nowrap' }}
          href={{
            pathname: s3ToCDN(path),
          }}
          passHref
        >
          <Typography.Text
            color="blue100"
            style={{ textDecoration: 'underline' }}
            variant="regular/14"
          >
            {name}
          </Typography.Text>
        </Link>
      </div>
    );
  }
  return null;
};

export const UploadFileEmailModePlugin = (props?: MediaProps): SlatePlugin => {
  return {
    renderElement: renderFileUpload(props),
    voidTypes: [MediaType.FILE],
  };
};
